import { LegalPage, LegalSection } from "@/pages/legal/LegalPage";

export default function CGU() {
  return (
    <LegalPage
      testId="page-cgu"
      title="Conditions Générales d'Utilisation"
      updated="Juillet 2025"
      seoDescription="Conditions Générales d'Utilisation de PlanPermis, la plateforme qui trouve une place en permis accéléré auprès de son réseau d'auto-écoles partenaires."
    >
      <p>
        Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'utilisation du site et du
        service PlanPermis (le « Service »), édité par la société TETRISNEWS SAS, SIREN 941 137 432, dont le siège est
        situé 149 avenue du Maine, 75014 Paris. En utilisant le Service, vous acceptez sans réserve les présentes CGU.
      </p>

      <LegalSection title="1. Objet du Service">
        <p>
          PlanPermis est une plateforme de mise en relation entre des personnes souhaitant passer leur permis de
          conduire en <strong>formation accélérée</strong> (« Élèves ») et des auto-écoles partenaires
          (« Partenaires ») qui réservent chaque mois un nombre <strong>limité de places</strong> dédiées au permis
          accéléré. L'intérêt du Service : là où une auto-école n'a souvent aucune date rapide à proposer, PlanPermis
          dispose en permanence de places en accéléré mutualisées entre ses Partenaires.
        </p>
      </LegalSection>

      <LegalSection title="2. Nature du service — PlanPermis n'est pas une auto-école">
        <p>
          PlanPermis agit exclusivement en qualité d'intermédiaire et d'apporteur d'affaires. PlanPermis n'est pas une
          auto-école, ne dispense aucune formation et ne délivre pas de places d'examen. Les places d'examen sont
          attribuées exclusivement par l'administration compétente. La prestation de formation (y compris la formule
          accélérée) est fournie par le Partenaire choisi, sous sa seule responsabilité, au tarif qu'il annonce.
        </p>
      </LegalSection>

      <LegalSection title="3. Gratuité pour l'Élève">
        <p>
          L'utilisation du Service est <strong>entièrement gratuite et sans engagement</strong> pour l'Élève. Aucun
          acompte n'est demandé par PlanPermis. L'Élève règle uniquement sa formation directement auprès de
          l'auto-école retenue, au tarif annoncé par celle-ci.
        </p>
      </LegalSection>

      <LegalSection title="4. Fonctionnement de la réservation">
        <p>
          L'Élève choisit une ville puis un mois, et visualise le nombre de places restantes en permis accéléré ainsi
          que des <strong>offres anonymisées</strong> (prix, nombre d'heures, boîte, code inclus ou non) sans voir le
          nom des auto-écoles. En sélectionnant une offre, l'Élève réserve gratuitement sa place et dépose ses
          documents en ligne. PlanPermis transmet ensuite le dossier à l'auto-école concernée, qui prend contact avec
          l'Élève pour finaliser l'inscription.
        </p>
      </LegalSection>

      <LegalSection title="5. Confirmation et libération automatique des places">
        <p>
          Après transmission du dossier, l'Élève reçoit une demande de confirmation par e-mail. <strong>À défaut de
          confirmation dans le délai indiqué (2 jours par défaut)</strong>, ou en cas de réponse négative, la place
          est automatiquement <strong>libérée</strong> et proposée à un autre Élève. Un rappel est adressé à l'Élève
          avant la libération.
        </p>
      </LegalSection>

      <LegalSection title="6. Bon usage et lutte contre les abus">
        <p>
          Les places en permis accéléré sont rares et mobilisent des créneaux réservés par les Partenaires. Afin d'en
          garantir un accès équitable, l'Élève s'engage à ne réserver que s'il a réellement l'intention de donner
          suite.
        </p>
        <p>
          <strong>
            Si un Élève réserve une place à deux (2) reprises sans donner suite (place non confirmée, non-présentation
            ou réponse négative) sur une période de trois (3) mois glissants, son profil est automatiquement bloqué et
            il ne pourra plus effectuer de réservation sur la plateforme pendant trois (3) mois.
          </strong>{" "}
          Ce blocage est apprécié sur la base de l'adresse e-mail et/ou du numéro de téléphone fournis. En cas d'erreur
          manifeste, l'Élève peut nous contacter pour réexamen.
        </p>
      </LegalSection>

      <LegalSection title="7. Obligations de l'utilisateur">
        <p>
          L'utilisateur s'engage à fournir des informations exactes et à jour, à ne pas usurper l'identité d'un tiers,
          à ne pas créer de réservations multiples ou frauduleuses, et à utiliser le Service conformément à la loi et
          aux présentes CGU.
        </p>
      </LegalSection>

      <LegalSection title="8. Obligations des auto-écoles partenaires">
        <p>
          Les Partenaires s'engagent à publier des offres de formation en permis accéléré exactes (prix, nombre
          d'heures, type de boîte, code inclus ou non, options) et à honorer les places qu'ils mettent à disposition.
          Les offres sont validées par PlanPermis avant publication et restent anonymes jusqu'à la transmission du
          dossier.
        </p>
      </LegalSection>

      <LegalSection title="9. Données personnelles">
        <p>
          Le traitement des données personnelles est décrit dans notre Politique de confidentialité, accessible depuis
          le pied de page. Les données de réservation (y compris l'historique des places non confirmées) sont
          conservées le temps nécessaire à la gestion du Service et à la prévention des abus.
        </p>
      </LegalSection>

      <LegalSection title="10. Propriété intellectuelle">
        <p>
          L'ensemble des éléments du site (marque, logo, textes, interface) est protégé par le droit de la propriété
          intellectuelle et demeure la propriété de PlanPermis ou de ses ayants droit.
        </p>
      </LegalSection>

      <LegalSection title="11. Responsabilité">
        <p>
          PlanPermis met en œuvre ses meilleurs efforts pour assurer la disponibilité du Service mais ne saurait être
          tenu responsable des relations contractuelles nouées entre l'Élève et le Partenaire, ni de la qualité des
          prestations délivrées par le Partenaire, ni de l'obtention ou de la réussite à l'examen.
        </p>
      </LegalSection>

      <LegalSection title="12. Modification des CGU">
        <p>
          PlanPermis se réserve le droit de modifier les présentes CGU à tout moment. La version applicable est celle
          en vigueur au jour de l'utilisation du Service.
        </p>
      </LegalSection>

      <LegalSection title="13. Droit applicable">
        <p>
          Les présentes CGU sont soumises au droit français. À défaut de résolution amiable, tout litige sera porté
          devant les tribunaux compétents.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
